export default "/_next/static/images/myevent-avatar-bg-e0f25214a1604fc0b6be6de672b520e8.png";